import CardComponent from "./CardComponent";
import { useEffect } from "react";

import { useSelector, useDispatch } from "react-redux";
import { fetchMovies } from "../stores/actions/movieAction";

export default function Cardlist() {
  const dispatch = useDispatch();
  const { movies } = useSelector((state) => {
    return state.movies;
  });

  useEffect(() => {
    dispatch(fetchMovies());
  }, []);
  return (
    <div className="container mx-auto grid grid-cols-4 gap-4 mt-4">
      {movies.map((el) => (
        <CardComponent el={el} key={el.id}></CardComponent>
      ))}
    </div>
  );
}
